import { ActivatedRouteSnapshot } from '@angular/router';
import { TokenService } from './../token/token.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ModuleGuard  {

    constructor(private tokenService: TokenService) { }

    canActivate(route: ActivatedRouteSnapshot) {
        const permission = route.data['permission'];
        return this.tokenService.checkPermission(permission);
    }
}
